import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const authToken = useSelector((state) => state.fetchSignin.authToken);
  let location = useLocation();
  return authToken ? (
    <Outlet />
  ) : (
    <Navigate to={`/login`} replace state={{ from: location }} />
  );
};

export default PrivateRoute;
